import { render } from "./channelAccount.vue?vue&type=template&id=758eb0d1&scoped=true"
import script from "./channelAccount.vue?vue&type=script&lang=js"
export * from "./channelAccount.vue?vue&type=script&lang=js"

import "./channelAccount.vue?vue&type=style&index=0&id=758eb0d1&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758eb0d1"]])

export default __exports__